__turbopack_context__.v({
  "accordionContent": "YbN0wW_accordionContent",
  "blockquote": "YbN0wW_blockquote",
  "codeBlock": "YbN0wW_codeBlock",
  "codeBlockWrapper": "YbN0wW_codeBlockWrapper",
  "codeSnippetWrapper": "YbN0wW_codeSnippetWrapper",
  "collapsibleWrapper": "YbN0wW_collapsibleWrapper",
  "container": "YbN0wW_container",
  "h1": "YbN0wW_h1",
  "h2": "YbN0wW_h2",
  "h3": "YbN0wW_h3",
  "h4": "YbN0wW_h4",
  "iframe": "YbN0wW_iframe",
  "image": "YbN0wW_image",
  "inlineCode": "YbN0wW_inlineCode",
  "link": "YbN0wW_link",
  "list": "YbN0wW_list",
  "listItem": "YbN0wW_listItem",
  "orderedList": "YbN0wW_orderedList",
  "paragraph": "YbN0wW_paragraph",
  "table": "YbN0wW_table",
  "tableWrapper": "YbN0wW_tableWrapper",
  "tbody": "YbN0wW_tbody",
  "td": "YbN0wW_td",
  "th": "YbN0wW_th",
  "thead": "YbN0wW_thead",
  "tr": "YbN0wW_tr",
});
